// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"fc875bf9","167":"e5ede047","174":"c33fde27","592":"a60c64ab"}[chunkId] + ".chunk.js";
};